import { useEffect, useState } from "react"
import { Identification } from "../../../icons/identification"
import { Button } from "../../ui/Button"
import { Dialog, DialogContent, DialogTrigger } from "../../ui/Modal"
import { ContractDialog } from "../signature/ContractDialog"
import { useLocation } from "react-router-dom"

export const VeryficationOptions = ({ cncode }) => {
    const [openModal, setOpenModal] = useState(false);

    const [error, setError] = useState(false)

    const location = useLocation();

    useEffect(() => {
        if (location && location.state) {
            if (location.state.status === 'failed') {
              setError(true)
            }
          }
    },[location])

    return (
        <div className="lg:left-[480px] pt-10 absolute top-0 w-full lg:w-[calc(100vw-500px)] max-lg:p-2 max-lg:pb-[130px] flex flex-col lg:gap-10 pb-10 max-lg:gap-4">
            <h2>Πώς επιθυμείς να επαληθεύσεις την ταυτότητά σου;</h2>
            {error &&
                <div className="p-4 bg-[#FFD5D5] rounded-[12px]">
                    Προέκυψε σφάλμα κατά τη σύνδεσή σου στο Gov.gr, προσπάθησε ξανά.
                </div>}
        <div
        style={{
        boxShadow: '0px 2px 6px 0px #63636333'
        }}
        className="bg-white rounded-[12px] p-10 gap-6 flex flex-col max-lg:border max-lg:border-[#A5A5A5]">
            <div className="flex gap-2 items-center flex">
                <Identification/>
                <h3>Υποβολή ταυτότητας</h3>
            </div>
            <p>Με την επιλογή αυτή, θα σου ζητηθεί να ανεβάσεις φωτογραφίες και των δύο όψεων της ταυτότητάς σου.</p>
                <div className="w-full flex justify-end">
                <Dialog
                    open={openModal}
                    onOpenChange={(open) => setOpenModal(open)}
                >
                    <DialogTrigger className='max-lg:w-full'>
                    <Button
                        className={
                        'text-white bg-[#D4002A] py-3 px-10 rounded-[6px] max-lg:w-full'
                        }
                    >
                        Επόμενο
                    </Button>
                    </DialogTrigger>
                    <DialogContent  className={'max-lg:h-full'}>
                    <ContractDialog />
                    </DialogContent>
                </Dialog>
                {/* <Button className="text-white bg-[#D4002A] py-3 px-10 rounded-[6px]" onClick={()=>{setUserSelection(true)}}>Procced</Button> */}
            </div>
        </div>
        <div
        style={{
        boxShadow: '0px 2px 6px 0px #63636333'
        }}
        className="bg-white rounded-[12px] p-10 gap-6 flex flex-col max-lg:border max-lg:border-[#A5A5A5]">
            <div className="flex gap-2 items-center flex max-lg:items-start">
                <img width={40} height={40} alt="" src="/avis/images/govIcon.png" className={'stroke-black'}/>
                <h3>Μέσω της υπηρεσίας «Συστηθείτε-Know Your Customer»</h3>
            </div>
            <p>Η υπηρεσία «Συστηθείτε-Know Your Customer» (eGov-KYC) είναι μια ψηφιακή εναλλακτική για να ολοκληρώσεις εύκολα και γρήγορα τη διαδικασία ταυτοποίησης, καθώς αντλεί τα στοιχεία σου σε πραγματικό χρόνο από το μητρώο της Γενικής Γραμματείας Πληροφοριακών Συστημάτων, μετά τη συγκατάθεσή σου.</p>
            <div className="w-full flex justify-end">
                <Button onClick={() => {
                    window.open(`${process.env.REACT_APP_KYC_URL}/oauth?response_type=code&state=${cncode}&client_id=${process.env.REACT_APP_KYC_CLIENT_ID}&redirect_uri=${process.env.REACT_APP_BASE_URL}/KYC/callback&lang=el&scope=identity%20income%20contactInfo%20professionalActivity`,"_self")
                }} className="text-white bg-[#D4002A] py-3 px-10 rounded-[6px] max-lg:w-full">Επόμενο</Button>
            </div>
        </div>
    </div>
    )
}